import { Component, HostBinding, ViewChild } from '@angular/core';
import { FrontendFormElementInput } from '../../formelementinput.class';
import { FrontendFormElementWrapper } from '../../formelementwrapper.class';

@Component({
  selector: 'app-input-avatar',
  templateUrl: './input-avatar.component.html',
  styleUrls: ['./input-avatar.component.scss']
})
export class InputAvatarWrapperComponent extends FrontendFormElementWrapper {

  @ViewChild('formInput', {static: true})
  formElementInstanceValue: FrontendFormElementInput;

  formElementInstance(): FrontendFormElementInput {
    return this.formElementInstanceValue;
  }

  @HostBinding('class')
  get getClasses(): string {
    return super.getComponentClassesRendered();
  }
}
